import { LoaderFunctionArgs } from 'react-router-dom';
import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';

export async function medicationsLoader() {
    const medications = await queryClient.fetchQuery({
        queryKey: ['custom-medication', 'list'],
        queryFn: async () => {
            const { data } = await api.customMedication.list();
            return data;
        },
    });
    return medications;
}

export async function medicationLoader({ params }: LoaderFunctionArgs) {
    const medication = await queryClient.fetchQuery({
        queryKey: ['custom-medication', params.medicationId],
        queryFn: async () => {
            const { data } = await api.customMedication.get(params.medicationId as string);
            return data;
        },
    });
    return medication;
}
